import { REQUEST_URL } from "../constants";
import { RequestUtil, RequestFileUtil } from "../utils";
import { NewsInputModel } from "../models";

export const NewsService = {
  getAllNewsPageByLanguage,
  getNewsPage,
  createNewsPage,
  uploadImageNewsPage,
  deleteNewsPage,
  updateNewsPage,
};

async function getAllNewsPageByLanguage(query: { languageId: any; categoryId: string }) {
  const url = REQUEST_URL.GET_ALL_NEWS_PAGE_BY_LANGUAGE;

  return RequestUtil.get({ url, query });
}

async function getNewsPage(code: string, query?: { languageId?: string }) {
  const url = REQUEST_URL.GET_NEWS_PAGE.replace("{CODE}", code);

  return RequestUtil.get({ url, query });
}

async function createNewsPage(data: NewsInputModel[]) {
  const url = REQUEST_URL.CREATE_NEWS_PAGE;

  return RequestUtil.post({ url, data });
}

async function uploadImageNewsPage(formData: FormData) {
  const url = REQUEST_URL.IMAGE.UPLOAD_NEWS;

  return RequestFileUtil.post({ url, data: formData });
}

async function updateNewsPage(code: string, data: NewsInputModel[]) {
  const url = REQUEST_URL.UPDATE_NEWS_PAGE.replace("{CODE}", code);

  return RequestUtil.put({ url, data });
}

async function deleteNewsPage(code: string) {
  const url = REQUEST_URL.DELETE_NEWS_PAGE.replace("{CODE}", code);

  return RequestUtil.delete({ url });
}
